import { render, staticRenderFns } from "./MonthlyTaxPublic.vue?vue&type=template&id=09585c60"
import script from "./MonthlyTaxPublic.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports